{
  "groups": {
    "referenceNumber": "參考編號",
    "appointmentStartTimes": "預約開始時間",
    "appointmentNotifications": "預約通知",
    "appointmentStatuses": "預約狀態",
    "customAppointmentsGrid": "自訂預約格狀檢視",
    "limiter": "限制器",
    "schedulingPortal": "預約入口網站",
    "dockSelection": "月台選擇",
    "timeDisplay": "時間顯示",
    "gateManagement": "門禁管理",
    "smartGate": "SmartGate",
    "idValidation": "身分驗證",
    "appointmentValidation": "預約驗證",
    "other": "其他",
    "handlingUnits": "裝卸單位"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "參考編號是您可以在承運商進行預約時向其索取的參考資料。",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "決定允許預約開始的時間間隔。",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "管理此{entity}的所有預約通知類型。",
    "manageTheSchedulingPortalSettingsForThisEntity": "管理此{entity}的預約入口網站設定",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "裝卸單位是在預約排程期間用於索取單位數量（例如棧板）的數字欄位。將其加入您的表單即可同時啟用限制器功能。",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "限制器可讓您設定每天可排定的預約或裝卸單位（例如棧板）數量上限。"
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "參考編號最少數量",
    "maximumAmountOfReferenceNumbers": "參考編號最多數量",
    "includeReferenceNumberFieldOnAllAppointmentForms": "是否在所有預約表單中加入參考編號欄位？",
    "referenceNumberFieldName": "參考編號欄位名稱",
    "referenceNumberHelperText": "參考編號說明文字",
    "makeReferenceNumberARequiredField": "是否將參考編號設為必填欄位？",
    "allowAppointmentsForThisEntityToStartAt": "允許此{entity}的預約開始於：",
    "enableAppointmentNotificationsForThisEntity": "是否為此{entity}啟用預約通知？",
    "selectEachDesiredStartTimeIndividually": "逐一選擇所需的開始時間",
    "hideTheLoadTypeDuration": "是否隱藏貨物類型時長？",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "上傳您的{entity}標誌，以顯示在預約入口網站及所有電子郵件通知中",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "上傳您的倉庫場站地圖，以顯示在預約入口網站中",
    "statusForNewlyCreatedAppointments": "新建立預約的狀態",
    "muteAppointmentNotifications": "靜音預約通知",
    "allowDockSelectionInSchedulingPortal": "是否允許在預約入口網站中選擇月台？",
    "theStatusThatFollowsArrivedIs": "「已抵達」之後的狀態為",
    "displayTimeIn": "時間顯示格式：",
    "customizeAppointmentDetails": "自訂預約詳細資料",
    "gridTileConfig": "格狀圖塊設定",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "強制使用地理圍欄，要求司機提供即時位置",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "是否要在司機報到後向其顯示其他資訊？（選填）",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "是否禁止在預約入口網站中重新安排預約？",
    "revertToRequestedOnCarrierReschedule": "承運商重新安排時恢復為「已申請」",
    "observationMatchAttribute": "觀測紀錄比對屬性",
    "observationMatchTimeWindow": "觀測紀錄比對時間範圍",
    "autoDepartAssets": "自動將資產設為離開",
    "autoCreateAssets": "自動建立資產",
    "gateFeedColumns": "Gate Feed 欄位",
    "checkInEarlyThreshold": "提早報到門檻",
    "checkInLateThreshold": "延遲報到門檻",
    "technicalContactEmailAddress": "技術聯絡人電子郵件地址",
    "technicalContactEmailThrottleMinutes": "技術聯絡人電子郵件發送間隔（分鐘）",
    "requireUniqueReferenceNumbers": "要求參考編號不得重複",
    "appointmentStartTimeInterval": "預約開始時間間隔",
    "referenceNumberInputMode": "參考編號輸入模式",
    "uploadWarehouseYardMap": "上傳您的倉庫場站地圖，以顯示在預約入口網站中",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "是否在所有預約表單中加入裝卸單位欄位？",
    "handlingUnitsLabel": "裝卸單位標籤",
    "handlingUnitsHelperText": "裝卸單位說明文字",
    "makeHandlingUnitsARequiredField": "是否將裝卸單位設為必填欄位？",
    "maximumHandlingUnitsValueForAnAppointment": "單一預約的裝卸單位最大值",
    "minimumHandlingUnitsValueForAnAppointment": "單一預約的裝卸單位最小值",
    "checkOutBolSignedRequired": "離場時必須簽署 BOL",
    "checkOutBolNotLoadingErrorMessage": "離場時 BOL 無法載入的錯誤訊息",
    "checkOutIdentifier": "離場識別資訊",
    "enableCheckInIdValidationPersona": "啟用報到身分驗證（Persona）",
    "requireCheckInIdValidationToCompleteCheckIn": "要求完成報到身分驗證才能完成報到",
    "checkInIdValidationTemplate": "報到身分驗證範本",
    "geofenceRadius": "地理圍欄半徑",
    "createAppointmentOnExternalValidationFailure": "外部驗證失敗時仍建立預約",
    "enableOverrideLimiterFunction": "啟用覆寫限制器功能",
    "receiveUnplannedCheckInEmailNotifications": "接收未排定報到的電子郵件通知",
    "driversMustEnterAReferenceNumberToCheckIn": "司機必須輸入參考編號才能報到",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "司機僅能在參考編號與已排定預約相符時報到",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "司機在報到時略過參考編號步驟",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "自訂司機報到後收到的第一則簡訊（選填）",
    "includeYardMapImageInTheFirstCheckInSms": "是否在第一則報到簡訊中附上場站地圖圖片？",
    "automaticallyDeleteStoredIdValidations": "自動刪除已儲存的身分驗證資料",
    "deleteStoredIdValidationsAfter": "已儲存的身分驗證資料刪除期限",
    "displayDatesAs": "日期顯示格式：",
    "displayTimeAs": "時間顯示格式："
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "每個預約至少需要此數量的參考編號",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "每個預約最多只能有此數量的參考編號",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "參考編號欄位的顯示名稱。例如：「PO 號碼」、「貨件 ID」",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "協助填寫參考編號欄位的其他資訊。例如：「參考編號應以 OD-XX 開頭」",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "所有排定的預約都必須填寫參考編號",
    "thisOnlyAffectsNewlyCreatedAppointments": "此設定僅影響新建立的預約",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "在預約入口網站預約時，時長會顯示在貨物類型選擇清單中",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "允許在預約入口網站預約時選擇月台",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "此設定可在「已抵達」與「已完成」之間選用額外的「作業中」狀態",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "決定此組織所有使用者在整個平台上（包括預約格狀檢視與報表）的時間顯示方式。",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "啟用以切換至新的可自訂預約詳細資料系統",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "使用者設定格狀圖塊的顯示方式。",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "此設定會要求取得司機的位置，並在司機距離您的倉庫超過一英里時禁止其報到。",
    "preventCarriersFromReschedulingAppointmentsOptional": "禁止承運商重新安排預約。（選填）",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "當承運商重新安排「已排定」的預約時，將其改回「已申請」以重新核准",
    "attributeToBeUsedForMatchingObservations": "用於比對觀測紀錄的屬性",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "在報到時間前後納入觀測紀錄的分鐘數",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "承運商可在預約開始時間前多少分鐘報到",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "承運商可在預約開始時間後多少分鐘內報到",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "接收技術問題與資訊的電子郵件地址",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "發生驗證伺服器錯誤時，傳送給技術聯絡人的通知之間的間隔時間。",
    "aListOfMutedAppointmentNotifications": "已靜音的預約通知清單。",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "所有排定的預約都必須使用不重複的參考編號",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "這是預約可開始時間之間的間隔分鐘數",
    "enableTheCustomAppointmentStartTimesSetting": "啟用自訂預約開始時間設定",
    "theInputModeForTheReferenceNumberField": "參考編號欄位的輸入模式",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "單位類型欄位的顯示名稱。例如：棧板數、墊木數",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "所有排定的預約都必須填寫單位類型欄位",
    "autoDepartAssetsOnReceivingOutgateEvent": "收到出閘事件時自動將資產設為離開",
    "autoCreateAssetsOnReceivingIngateEvent": "收到入閘事件時自動建立資產",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "AI Gate Feed 頁面中可用的欄位。必要欄位一律顯示。",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "即使預約驗證未通過仍建立預約",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "司機必須位於此半徑（英里）範圍內才能報到。僅在啟用地理圍欄時適用。",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "協助填寫單位類型欄位的其他資訊。例如：單位類型只能是數字",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "設定預約中裝卸單位欄位可輸入的最大數值",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "設定預約中裝卸單位欄位可輸入的最小數值",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "當限制器達到 100% 時，此功能僅允許倉庫使用者覆寫並建立或核准預約與單位",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "系統用於驗證離場表單的資產屬性",
    "enforceBolSigningOnCheckOutForm": "強制在離場表單上簽署 BOL",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "如果無法取得 BOL，承運商將無法簽署，因此會無法離場。您可以在此設定發生此情況時司機會看到的自訂說明。",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "在報到流程中顯示 Persona 元件以進行身分驗證",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "司機必須先通過 Persona 驗證才能完成報到",
    "personaTemplateUsedForCheckInIdentityVerification": "用於報到身分驗證的 Persona 範本",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "發生未排定報到時，倉庫訂閱者會收到電子郵件通知",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "此訊息將取代以簡訊傳送給司機的預設報到確認文字。留空即使用預設訊息。",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "在報到簡訊之後立即以另一則圖片訊息傳送您的場站地圖。此倉庫必須已上傳場站地圖。",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "保存期限屆滿後，已儲存的身分驗證紀錄將被永久刪除",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "已儲存的身分驗證資料在刪除前保留的天數",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "決定此公司使用者在公司相關介面中的日期顯示方式。",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "決定此公司使用者在公司相關介面中的時間顯示方式。"
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "與預約相關的參考編號",
    "insertMessageHere": "在此輸入訊息"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "整點（:00）",
      "topAndBottomOfTheHour00And30": "整點與半點（:00 和 :30）",
      "everyTwentyMinutes0020And40": "每 20 分鐘（:00、:20 和 :40）",
      "everyQuarterOfTheHour001530And45": "每 15 分鐘（:00、:15、:30 和 :45）",
      "customStartTimes": "自訂開始時間"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 分鐘",
      "30Minutes": "30 分鐘",
      "60Minutes": "60 分鐘",
      "90Minutes": "90 分鐘"
    },
    "observationMatchAttribute": {
      "licensePlate": "車牌號碼",
      "dotNumber": "DOT 編號",
      "any": "任一",
      "cascade": "依序比對"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "英數字",
      "numeric": "數字"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "已排定",
      "requested": "已申請"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "作業中",
      "completed": "已完成"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "否，不加入參考編號欄位",
      "yesIncludeTheReferenceNumberField": "是，加入參考編號欄位"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "否，不隱藏貨物類型時長",
      "yesHideTheLoadTypeDuration": "是，隱藏貨物類型時長"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "否，停用預約通知",
      "yesEnableAppointmentNotifications": "是，啟用預約通知"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "否，不允許選擇月台",
      "yesAllowTheDockSelection": "是，允許選擇月台"
    },
    "displayTimeIn": {
      "regularTime12Hour": "一般時間（12 小時制）",
      "militaryTime24Hour": "24 小時制"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "允許在預約入口網站中重新安排",
      "preventReschedulingInTheSchedulingPortal": "禁止在預約入口網站中重新安排"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "承運商重新安排時恢復為「已申請」",
      "keepStatusUnchangedOnCarrierReschedule": "承運商重新安排時維持狀態不變"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "否，不將參考編號設為必填欄位",
      "yesMakeReferenceNumberARequiredField": "是，將參考編號設為必填欄位"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "否，不要求參考編號不得重複",
      "yesRequireUniqueReferenceNumbers": "是，要求參考編號不得重複"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "否，不將裝卸單位設為必填欄位",
      "yesMakeHandlingUnitsARequiredField": "是，將裝卸單位設為必填欄位"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "否，不加入裝卸單位欄位",
      "yesIncludeTheHandlingUnitsField": "是，加入裝卸單位欄位"
    },
    "checkOutIdentifier": {
      "licensePlate": "車牌號碼",
      "phoneNumber": "電話號碼",
      "any": "任一"
    },
    "enableCheckInIdValidationPersona": {
      "no": "否",
      "yes": "是"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "否",
      "yes": "是"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "駕照 - 正面 - 1 次重試",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "駕照 - 正面、條碼、臉部，僅限美國，1 次重試"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "否",
      "yes": "是"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/YYYY",
      "ddMmYyyy": "DD/MM/YYYY",
      "yyyyMmDd": "YYYY-MM-DD",
      "tueMmDdYyyy": "週二, MM/DD/YYYY",
      "tueDdMmYyyy": "週二, DD/MM/YYYY",
      "tueYyyyMmDd": "週二, YYYY-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 小時制（例如 7:00 AM）",
      "24HourEG0700": "24 小時制（例如 07:00）"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "例如：7:00 AM / 7:00 PM",
      "eG07001900": "例如：07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "注意：",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "如果留空，將套用預設名稱",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "如果留空，將套用預設說明文字",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "啟用此選項不會影響已在個別預約層級停用的通知。",
    "ifLeftEmptyNoNotificationsWillBeSent": "如果留空，將不會傳送任何通知",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "已指派給已取消或未到預約的參考編號，可在新預約中重複使用",
    "ifEmptyTheDefaultNameWillBeApplied": "如果留空，將套用預設名稱"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "司機",
    "checkInSms": "報到簡訊",
    "dataRetention": "資料保存"
  }
}
